<template>
  <div class="form-group mb-5">
    <label class="required fs-xl mt-0"> Customer </label>
    <div class="input-group">
      <CustomSelect
        placeholder="Choose client"
        :selected="selectedId"
        :options="customers"
        :selectable="(option: CompanyWithLabel) => !option.status.includes('inactive')"
        :filter="customersFilter"
        @selected="onSelect"
      >
        <template #custom_option="{ option }: { option: CompanyWithLabel }">
          <div :class="'item-' + option.status">
            <span class="status" />
            <span class="name">{{ option.label }}</span>
            (Client number: {{ option.clientNumber }}; Email: {{ option.email }}; Phone: {{ option.phoneNumber }})
          </div>
        </template>
        <template v-if="createCustomerAllowed" #custom_list-footer>
          <div class="list-footer">
            <div class="create-client" @click="onCreate">Create New Customer</div>
          </div>
        </template>
      </CustomSelect>
    </div>
    <div v-if="error" class="text-danger">
      {{ error }}
    </div>

    <CreateNewCustomerModal :id="CREATE_NEW_CUSTOMER" />
  </div>
</template>

<script lang="ts">
import type { CompanyWithLabel } from '@/types/Models/Company'
import { computed, defineComponent, onMounted, type ComputedRef } from 'vue'
import { CREATE_NEW_CUSTOMER } from '@/const/ModalTypes'
import { openModal } from '@/services/Modal'
import { useCustomersStore } from '@/store/customers'
import CustomSelect from '@/views/Components/Elements/Form/CustomSelect.vue'
import CreateNewCustomerModal from '@/views/Modals/Customer/CreateNewCustomerModal.vue'

export default defineComponent({
  name: 'CustomerSelect',
  components: {
    CreateNewCustomerModal,
    CustomSelect,
  },
  props: {
    selectedId: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: '',
    },
    createCustomerAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['selected'],
  setup(props, { emit }) {
    const customersStore = useCustomersStore()

    const customers: ComputedRef<CompanyWithLabel[]> = computed(() => customersStore.allCustomers)

    const customersFilter = (option: CompanyWithLabel, label: any, search: string) => {
      const temp = (search.trim() === '@' ? '' : search).toLowerCase()
      return option.name
        ? option.label.toLowerCase().indexOf(temp) > -1 ||
            option.name.toLowerCase().indexOf(temp) > -1 ||
            option.email.toLowerCase().indexOf(temp) > -1
        : label
    }

    const onSelect = (id: string) => emit('selected', id)
    const onCreate = () => openModal(CREATE_NEW_CUSTOMER)

    onMounted(() => {
      customersStore.fetchAll()
    })

    return {
      customers,
      customersFilter,
      onSelect,
      onCreate,
      CREATE_NEW_CUSTOMER,
    }
  },
})
</script>
